class SearchInput extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleInput = this.handleInput.bind(this)
    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleDropdownOpen = this.handleDropdownOpen.bind(this)
    this.handleDropdownClose = this.handleDropdownClose.bind(this)

    if (this?.els?.input?.exists) {
      this.listeners.add(this.els.input.element, 'input', this.handleInput)
      this.listeners.add(
        this.els.input.element,
        'focus',
        this.handleDropdownOpen,
      )
      this.listeners.add(
        this.els.input.element,
        'click',
        this.handleDropdownOpen,
      )
    }

    if (this?.externalEls?.trigger?.exists) {
      this.listeners.add(
        this.externalEls.trigger.element,
        'click',
        this.handleExternalTrigger,
      )
    }

    if (this?.els?.closeDropdown?.exists) {
      this.listeners.add(
        this.els.closeDropdown.element,
        'click',
        this.handleDropdownClose,
      )
    }
  }

  handleInput () {
    const searchTerm = this.els.input.element.value.trim()

    if (!document.body.classList.contains('util-SearchOpen')) {
      this.handleDropdownOpen()
    }

    window.theme.searchAutocomplete.eventBus.publish(
      'searchAutoComplete:ui:term:updated',
      {
        term: searchTerm,
      },
    )
  }

  handleExternalTrigger () {
    window.theme.searchAutocomplete.eventBus.publish(
      'searchAutoComplete:ui:dropdown:open',
    )

    document.body.classList.add('util-SearchOpen')
  }

  handleDropdownOpen () {
    window.theme.searchAutocomplete.eventBus.publish(
      'searchAutoComplete:ui:dropdown:open',
    )

    this.els.input.element.focus()

    document.body.classList.add('util-SearchOpen')
  }

  handleDropdownClose () {
    window.theme.searchAutocomplete.eventBus.publish(
      'searchAutoComplete:ui:dropdown:close',
    )

    this.els.input.element.blur()

    document.body.classList.remove('util-SearchOpen')
  }
}

if (!customElements.get('search-input')) {
  customElements.define('search-input', SearchInput)
}
